import { useState, useEffect } from 'react'
import { Modal, Paper, Transition } from '@mantine/core'
import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'

function AuthModal({ opened, onClose, initialMode = 'login' }) {
  const [mode, setMode] = useState(initialMode) // 'login' or 'register'

  // Update mode when initialMode prop changes
  useEffect(() => {
    setMode(initialMode)
  }, [initialMode])

  const handleSuccess = (userData) => {
    // Close modal on successful auth
    onClose()
    // Reset to login mode for next time
    setMode('login')
  }

  const handleSwitchToRegister = () => {
    setMode('register')
  }

  const handleSwitchToLogin = () => {
    setMode('login')
  }

  const handleModalClose = () => {
    // Reset to login mode when modal is closed
    setMode('login')
    onClose()
  }

  return (
    <Modal
      opened={opened}
      onClose={handleModalClose}
      title={mode === 'login' ? 'Sign In' : 'Create Account'}
      centered
      size="md"
      padding="xl"
      radius="md"
      withCloseButton
      closeOnClickOutside={false}
      closeOnEscape={true}
    >
      <Paper p="md" radius="md">
        <Transition
          mounted={mode === 'login'}
          transition="fade"
          duration={200}
          timingFunction="ease"
        >
          {(styles) => (
            <div style={styles}>
              {mode === 'login' && (
                <LoginForm
                  onSuccess={handleSuccess}
                  onSwitchToRegister={handleSwitchToRegister}
                />
              )}
            </div>
          )}
        </Transition>

        <Transition
          mounted={mode === 'register'}
          transition="fade"
          duration={200}
          timingFunction="ease"
        >
          {(styles) => (
            <div style={styles}>
              {mode === 'register' && (
                <RegisterForm
                  onSuccess={handleSuccess}
                  onSwitchToLogin={handleSwitchToLogin}
                />
              )}
            </div>
          )}
        </Transition>
      </Paper>
    </Modal>
  )
}

export default AuthModal